<p class="search-host--title" translate="search-page.stay-in-style"></p>
<p class="search-host--subtitle" translate="search-page.matching-stays"></p>

<div class="search-host--router-outlet">
  <hotels></hotels>
</div>

<p class="search-host--more-action" (click)="actionClicked.emit('hotels')"><em>{{ 'search-page.more-hotels' | translate }}</em></p>
